import { render, staticRenderFns } from "./ScoresContainer.vue?vue&type=template&id=6219fe12&"
import script from "./ScoresContainer.vue?vue&type=script&lang=js&"
export * from "./ScoresContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports